import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, User, ShoppingCart } from 'lucide-react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { useAuth } from '../context/AuthContext';
import { getImageUrl } from '../utils/imageUrl';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Header = () => {
  const navigate = useNavigate();
  const { user, cart } = useAuth();
  const [settings, setSettings] = useState({
    siteName: 'ArqessenceShop',
    logoImage: ''
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/settings`);
      setSettings(response.data);
    } catch (error) {
      console.error('Erro ao carregar configurações');
    }
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div 
            className="flex items-center cursor-pointer" 
            onClick={() => navigate('/')}
          >
            {settings.logoImage ? (
              <img 
                src={getImageUrl(settings.logoImage)} 
                alt={settings.siteName}
                className="h-10 md:h-12 object-contain"
              />
            ) : (
              <h1 className="text-xl md:text-2xl font-bold" style={{ color: '#00A86B' }}>
                {settings.siteName}
              </h1>
            )}
          </div>

          {/* Navigation */}
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              onClick={() => navigate('/')}
              className="text-gray-700 hover:text-[#00A86B]"
            >
              <Home size={20} className="mr-2" />
              Início
            </Button>

            {user ? (
              <Button
                variant="ghost"
                onClick={() => navigate('/minha-conta')}
                className="text-gray-700 hover:text-[#00A86B]"
              >
                <User size={20} className="mr-2" />
                Minha Conta
              </Button>
            ) : (
              <Button
                variant="ghost"
                onClick={() => navigate('/entrar')}
                className="text-gray-700 hover:text-[#00A86B]"
              >
                <User size={20} className="mr-2" />
                Entrar
              </Button>
            )}

            <Button
              variant="ghost"
              onClick={() => navigate('/carrinho')}
              className="text-gray-700 hover:text-[#00A86B] relative"
            >
              <ShoppingCart size={20} className="mr-2" />
              Carrinho
              {cart && cart.length > 0 && (
                <Badge className="absolute -top-1 -right-1 bg-[#00A86B] text-white">
                  {cart.length}
                </Badge>
              )}
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
